import React from 'react';
import { useSelector } from 'react-redux';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import type { ClassNameMap } from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import { PayWallDescriptionItem } from 'components/PayWall/Redux/Reducer.type';
import { getPlansWithoutAddOns } from 'components/PayWall/Redux/Selectors';

import FeaturesList from './FeaturesList';

const useStyles = makeStyles((theme: HCPTheme) => ({
  listIconRoot: {
    fontSize: (theme.typography as any).htmlFontSize,
    minWidth: '20px',
  },
  listItemRoot: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  caption: {
    fontSize: theme.typography.body2.fontSize,
  },
  root: {},
}));

type PlanFeaturesProps = {
  featuresDescriptions: PayWallDescriptionItem[];
  addonsDescriptions: PayWallDescriptionItem[];
  classes?: ClassNameMap<'root'>;
};

const PlanAddOnsWrapper: React.FC = ({ children }) => {
  const classes = useStyles();
  const noAddonsPlanNames = useSelector(getPlansWithoutAddOns);

  return (
    <Box data-testid="plan-add-ons-wrapper">
      <Box px={2} mt={2}>
        <Typography variant="body2">Add-ons included*:</Typography>
      </Box>
      {children}
      <Box px={2}>
        <Typography variant="caption" className={classes.caption}>
          {`*Add-ons are an extra cost per month for ${noAddonsPlanNames} plans. Over $100 in value.`}
        </Typography>
      </Box>
    </Box>
  );
};

const PlanFeatures = (props: PlanFeaturesProps) => {
  const { featuresDescriptions, addonsDescriptions, classes: outsideClasses } = props;
  const classes = useStyles({ classes: outsideClasses });
  const featureListItems = [...featuresDescriptions];

  return (
    <Grid classes={{ root: classes.root }} container direction="column" data-testid="plan-features">
      <FeaturesList firstAsHeader features={featureListItems} />
      {addonsDescriptions.length > 0 && (
        <PlanAddOnsWrapper>
          <FeaturesList emphasizeFirst={false} features={addonsDescriptions} />
        </PlanAddOnsWrapper>
      )}
    </Grid>
  );
};

export default PlanFeatures;
